export const examSchedule = [
    {

        subject: "English",
        examDate: "13 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "101",
        maxMarks: "100",
        minMarks: "35",
        key:1
    },
    {

        subject: "Spanish",
        examDate: "14 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "104",
        maxMarks: "100",
        minMarks: "35",
        key:2
    },
    {

        subject: "Physics",
        examDate: "15 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "103",
        maxMarks: "100",
        minMarks: "35",
        key:3
    },
    {

        subject: "Chemistry",
        examDate: "16 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "105",
        maxMarks: "100",
        minMarks: "35",
        key:4
    },
    {

        subject: "Maths",
        examDate: "17 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "106",
        maxMarks: "100",
        minMarks: "35",
        key:5
    },
    {

        subject: "Computer",
        examDate: "18 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "102",
        maxMarks: "100",
        minMarks: "35",
        key:6
    },
    {

        subject: "Env Science",
        examDate: "19 May 2024",
        startTime: "09:30 AM",
        endTime: "10:45 AM",
        duration: "3 hrs",
        roomNo: "107",
        maxMarks: "100",
        minMarks: "35",
        key:7
    }
]
